(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kf-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseCarousel = (section) => {
      if (section.dataset.kfCarouselInitialised === 'true') return;

      if (section.dataset.kfDesignMode === 'true') {
        section.querySelectorAll('.kf-carousel__view-all-visual a[href]').forEach((link) => {
          link.removeAttribute('href');
          link.removeAttribute('target');
        });
      }

      const track = section.querySelector('[data-kf-carousel-track]');
      const controls = section.querySelector('[data-kf-carousel-controls]');
      const previousButton = section.querySelector('[data-kf-carousel-previous]');
      const nextButton = section.querySelector('[data-kf-carousel-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      section.dataset.kfCarouselInitialised = 'true';

      const getGap = () => {
        const trackStyles = window.getComputedStyle(track);
        return parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      };

      const getScrollAmount = () => {
        const firstItem = track.querySelector('.kf-carousel__item');

        return firstItem
          ? firstItem.getBoundingClientRect().width + getGap()
          : track.clientWidth;
      };

      const updateControls = () => {
        const maximumScroll = Math.max(
          0,
          track.scrollWidth - track.clientWidth
        );

        const hasOverflow = maximumScroll > 2;

        controls.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled =
          track.scrollLeft >= maximumScroll - 2;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', updateControls, {
        passive: true
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateControls);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateControls);
      }

      updateControls();
    };

    const initialiseAllCarousels = (root = document) => {
      if (root.matches?.('[data-kf-carousel]')) {
        initialiseCarousel(root);
      }

      root
        .querySelectorAll('[data-kf-carousel]')
        .forEach(initialiseCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialiseAllCarousels();
      });
    } else {
      initialiseAllCarousels();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAllCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-collection-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kf-collection-gallery')) {
    class KfCollectionGallery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.previousButton = this.querySelector('[data-gallery-previous]');
        this.nextButton = this.querySelector('[data-gallery-next]');
        this.currentLabel = this.querySelector('[data-gallery-current]');
        this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));

        if (!this.viewport || this.slides.length < 2) return;

        this.dataset.initialized = 'true';
        this.currentIndex = 0;
        this.scrollFrame = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.handleKeydown);

        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.galleryDot)));
        });

        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.viewport);
        this.updateNavigation();
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.handleScroll);
        this.viewport?.removeEventListener('keydown', this.handleKeydown);
        this.resizeObserver?.disconnect();

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      getVisibleSlideCount() {
        const firstSlide = this.slides[0];
        if (!firstSlide) return 1;

        const track = this.querySelector('.kf-collection-gallery__track');
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const slideWidth = firstSlide.getBoundingClientRect().width;

        return Math.max(1, Math.round(this.viewport.clientWidth / (slideWidth + gap)));
      }

      getMaximumStartIndex() {
        return Math.max(0, this.slides.length - this.getVisibleSlideCount());
      }

      getSlideLeft(slide) {
        return slide.offsetLeft - this.slides[0].offsetLeft;
      }

      getClosestIndex() {
        const maximumIndex = this.getMaximumStartIndex();
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          if (index > maximumIndex) return;

          const distance = Math.abs(this.getSlideLeft(slide) - this.viewport.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      goTo(requestedIndex) {
        const targetIndex = Math.min(Math.max(requestedIndex, 0), this.getMaximumStartIndex());
        const targetSlide = this.slides[targetIndex];
        if (!targetSlide) return;

        this.viewport.scrollTo({
          left: this.getSlideLeft(targetSlide),
          behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
        });
      }

      handleScroll() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);

        this.scrollFrame = requestAnimationFrame(() => {
          this.currentIndex = this.getClosestIndex();
          this.updateNavigation();
        });
      }

      handleKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.currentIndex + 1);
        }
      }

      handleResize() {
        this.currentIndex = Math.min(this.currentIndex, this.getMaximumStartIndex());
        this.viewport.scrollTo({ left: this.getSlideLeft(this.slides[this.currentIndex]), behavior: 'auto' });
        this.updateNavigation();
      }

      updateNavigation() {
        const maximumIndex = this.getMaximumStartIndex();

        if (this.currentLabel) this.currentLabel.textContent = String(this.currentIndex + 1);
        if (this.previousButton) this.previousButton.disabled = this.currentIndex <= 0;
        if (this.nextButton) this.nextButton.disabled = this.currentIndex >= maximumIndex;

        this.dots.forEach((dot, index) => {
          const isCurrent = index === this.currentIndex;
          dot.classList.toggle('kf-collection-gallery__dot--current', isCurrent);

          if (isCurrent) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('kf-collection-gallery', KfCollectionGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-colour-refine"] && !Shopify.designMode) return;
  try {
    

class KFColourRefine extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';

    this.range = this.querySelector('.kf-colour-refine__range');
    this.status = this.querySelector('[data-kf-colour-status]');

    if (!this.range || !this.status) return;

    this.loaded = false;
    this.activated = false;
    this.loadPromise = null;

    this.metadata = [];
    this.cards = new Map();

    this.range.addEventListener(
      'input',
      this.handleInput.bind(this)
    );

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => this.setupCollectionGrid(),
        { once: true }
      );
    } else {
      this.setupCollectionGrid();
    }
  }

  setupCollectionGrid() {
    this.resultsList =
      document.querySelector(
        'collection-component results-list[section-id]'
      );

    if (!this.resultsList) return;

    this.mainSectionId =
      this.resultsList.getAttribute('section-id');

    this.grid =
      this.resultsList.querySelector(
        '[data-testid="product-grid"]'
      );

    const wrapper =
      this.mainSectionId
        ? document.getElementById(
            `shopify-section-${this.mainSectionId}`
          )
        : null;

    if (!wrapper) return;

    this.gridObserver = new MutationObserver(() => {
      const currentGrid =
        document.querySelector(
          'collection-component results-list[section-id] [data-testid="product-grid"]'
        );

      /*
        If Shopify replaces the collection grid after
        filtering/sorting, reset the colour control.
      */
      if (
        currentGrid &&
        this.grid &&
        currentGrid !== this.grid
      ) {
        this.resetForNewGrid(currentGrid);
      }
    });

    this.gridObserver.observe(wrapper, {
      childList: true,
      subtree: true
    });
  }

  resetForNewGrid(newGrid) {
    this.grid = newGrid;

    this.resultsList =
      document.querySelector(
        'collection-component results-list[section-id]'
      );

    this.mainSectionId =
      this.resultsList?.getAttribute('section-id');

    this.loaded = false;
    this.activated = false;
    this.loadPromise = null;

    this.metadata = [];
    this.cards = new Map();

    this.range.value = '0';

    this.setStatus('Best selling');
    this.removeAttribute('aria-busy');
  }

  handleInput() {
    const value = Number(this.range.value);

    if (this.hasAttribute('aria-busy')) {
      this.setStatus('Preparing shade order…');
    } else {
      this.updateStatus(value);
    }

    /*
      Do absolutely nothing extra on the normal centre position.
      This keeps the initial collection behaviour unchanged.
    */
    if (value === 0 && !this.activated) {
      return;
    }

    /*
      First movement away from centre starts the background
      fetch. Further movements reuse the same promise.
    */
    if (!this.loaded) {
      this.ensureLoaded()
        .then(() => {
          const currentValue = Number(this.range.value);

          if (currentValue !== 0 || this.activated) {
            this.applyRanking(currentValue);
          } else {
            this.setStatus('Best selling');
          }
        })
        .catch((error) => {
          console.error(
            '[KF Colour Shade]',
            error
          );

          this.range.value = '0';

          this.setStatus(
            'Best selling'
          );

          this.removeAttribute('aria-busy');
        });

      return;
    }

    this.scheduleRanking(value);
  }

  updateStatus(value) {
    if (value === 0) {
      this.setStatus('Best selling');
      return;
    }

    if (value < 0) {
      this.setStatus('Lighter first');
      return;
    }

    this.setStatus('Darker first');
  }

  setStatus(text) {
    if (this.status) {
      this.status.textContent = text;
    }
  }

  ensureLoaded() {
    if (this.loaded) {
      return Promise.resolve();
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.setAttribute('aria-busy', 'true');
    this.setStatus('Preparing shade order…');

    this.loadPromise = Promise.all([
      this.loadRankingData(),
      this.loadProductCards()
    ])
      .then(([metadata, cards]) => {
        this.metadata = metadata;
        this.cards = cards;

        this.loaded = true;

        this.removeAttribute('aria-busy');

        this.updateStatus(
          Number(this.range.value)
        );
      })
      .finally(() => {
        this.loadPromise = null;
      });

    return this.loadPromise;
  }

  async loadRankingData() {
    /*
      Fetch page 1 first so we get the current filtered
      collection's page count.
    */
    const firstHTML =
      await this.fetchSection(
        this.dataset.sectionId,
        1
      );

    const first =
      this.parseRankingSection(firstHTML);

    const items = [...first.items];

    if (first.pages > 1) {
      const pages = [];

      for (
        let page = 2;
        page <= first.pages;
        page++
      ) {
        pages.push(page);
      }

      const remaining =
        await this.fetchInBatches(
          pages,
          3,
          async (page) => {
            const html =
              await this.fetchSection(
                this.dataset.sectionId,
                page
              );

            return this.parseRankingSection(
              html
            ).items;
          }
        );

      remaining.forEach((pageItems) => {
        items.push(...pageItems);
      });
    }

    const unique = new Map();

    items.forEach((item) => {
      if (!unique.has(String(item.id))) {
        unique.set(
          String(item.id),
          {
            id: String(item.id),
            order: Number(item.order),
            lightness:
              item.lightness === null
                ? null
                : Number(item.lightness)
          }
        );
      }
    });

    return Array.from(unique.values())
      .sort((a, b) => a.order - b.order);
  }

  async loadProductCards() {
    if (!this.mainSectionId) {
      throw new Error(
        'Main collection section not found.'
      );
    }

    const firstHTML =
      await this.fetchSection(
        this.mainSectionId,
        1
      );

    const first =
      this.parseProductSection(firstHTML);

    const allPages = [first];

    if (first.pages > 1) {
      const pages = [];

      for (
        let page = 2;
        page <= first.pages;
        page++
      ) {
        pages.push(page);
      }

      const remaining =
        await this.fetchInBatches(
          pages,
          2,
          async (page) => {
            const html =
              await this.fetchSection(
                this.mainSectionId,
                page
              );

            return this.parseProductSection(
              html
            );
          }
        );

      allPages.push(...remaining);
    }

    const cards = new Map();

    allPages.forEach((page) => {
      page.cards.forEach((card) => {
        const productId =
          card.dataset.productId;

        if (!productId) return;

        /*
          Force all additional product images to remain lazy.
          They will load normally as the customer scrolls.
        */
        card
          .querySelectorAll('img')
          .forEach((image) => {
            image.setAttribute(
              'loading',
              'lazy'
            );

            image.setAttribute(
              'fetchpriority',
              'low'
            );
          });

        if (!cards.has(productId)) {
          cards.set(productId, card);
        }
      });
    });

    return cards;
  }

  async fetchSection(sectionId, page) {
    const url =
      new URL(window.location.href);

    url.hash = '';

    url.searchParams.set(
      'section_id',
      sectionId
    );

    url.searchParams.set(
      'page',
      String(page)
    );

    /*
      Colour ranking always blends against the collection's
      normal Best selling order.
    */
    url.searchParams.set(
      'sort_by',
      'best-selling'
    );

    const response =
      await fetch(
        url.toString(),
        {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With':
              'XMLHttpRequest'
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        `Section request failed: ${response.status}`
      );
    }

    return response.text();
  }

  parseRankingSection(html) {
    /*
      Template content is inert.
      Images/scripts inside fetched markup are not activated.
    */
    const template =
      document.createElement('template');

    template.innerHTML = html;

    const data =
      template.content.querySelector(
        '[data-kf-colour-rank-data]'
      );

    const pagesElement =
      template.content.querySelector(
        '[data-kf-colour-rank-pages]'
      );

    let items = [];

    if (data?.textContent) {
      try {
        items =
          JSON.parse(data.textContent);
      } catch (error) {
        console.error(
          '[KF Colour Shade] Invalid ranking data',
          error
        );
      }
    }

    const pages =
      Number(
        pagesElement?.dataset
          .kfColourRankPages || 1
      );

    return {
      items,
      pages
    };
  }

  parseProductSection(html) {
    const template =
      document.createElement('template');

    template.innerHTML = html;

    const grid =
      template.content.querySelector(
        '[data-testid="product-grid"]'
      );

    if (!grid) {
      return {
        pages: 1,
        cards: []
      };
    }

    const cards =
      Array.from(
        grid.querySelectorAll(
          ':scope > li[data-product-id]'
        )
      );

    return {
      pages:
        Number(
          grid.dataset.lastPage || 1
        ),
      cards
    };
  }

  async fetchInBatches(
    values,
    batchSize,
    callback
  ) {
    const results = [];

    for (
      let i = 0;
      i < values.length;
      i += batchSize
    ) {
      const batch =
        values.slice(
          i,
          i + batchSize
        );

      const batchResults =
        await Promise.all(
          batch.map(callback)
        );

      results.push(...batchResults);
    }

    return results;
  }

  scheduleRanking(value) {
    if (this.rankFrame) {
      cancelAnimationFrame(
        this.rankFrame
      );
    }

    this.rankFrame =
      requestAnimationFrame(() => {
        this.applyRanking(value);
      });
  }

  applyRanking(value) {
    const currentGrid =
      document.querySelector(
        'collection-component results-list[section-id] [data-testid="product-grid"]'
      );

    if (!currentGrid) return;

    this.grid = currentGrid;

    const usable =
      this.metadata.filter(
        (item) =>
          this.cards.has(item.id)
      );

    if (!usable.length) return;

    const bestSelling =
      [...usable].sort(
        (a, b) =>
          a.order - b.order
      );

    let ordered =
      bestSelling;

    if (value !== 0) {
      const valid =
        usable.filter(
          (item) =>
            Number.isFinite(
              item.lightness
            )
        );

      const shadeOrder =
        [...valid].sort(
          (a, b) => {
            /*
              Negative = Light
              Positive = Dark
            */
            if (value < 0) {
              return (
                b.lightness -
                a.lightness
              );
            }

            return (
              a.lightness -
              b.lightness
            );
          }
        );

      const shadeRank =
        new Map();

      shadeOrder.forEach(
        (item, index) => {
          shadeRank.set(
            item.id,
            index
          );
        }
      );

      const strength =
        Math.abs(value) / 100;

      ordered =
        [...usable].sort(
          (a, b) => {
            const targetA =
              shadeRank.has(a.id)
                ? shadeRank.get(a.id)
                : a.order;

            const targetB =
              shadeRank.has(b.id)
                ? shadeRank.get(b.id)
                : b.order;

            const scoreA =
              a.order *
                (1 - strength) +
              targetA *
                strength;

            const scoreB =
              b.order *
                (1 - strength) +
              targetB *
                strength;

            return scoreA - scoreB;
          }
        );
    }

    const fragment =
      document.createDocumentFragment();

    const used =
      new Set();

    ordered.forEach((item) => {
      const card =
        this.cards.get(item.id);

      if (!card) return;

      used.add(item.id);
      fragment.appendChild(card);
    });

    /*
      Preserve any unexpected product without ranking data
      rather than dropping it from the collection.
    */
    this.cards.forEach(
      (card, productId) => {
        if (!used.has(productId)) {
          fragment.appendChild(card);
        }
      }
    );

    /*
      Once custom ranking is active we have the complete
      collection in the DOM, so Horizon must not append
      duplicate infinite-scroll pages.
    */
    this.resultsList =
      document.querySelector(
        'collection-component results-list[section-id]'
      );

    this.resultsList
      ?.querySelectorAll(
        '[ref="viewMoreNext"], [ref="viewMorePrevious"]'
      )
      .forEach(
        (element) =>
          element.remove()
      );

    currentGrid.dataset.lastPage = '1';

    currentGrid.replaceChildren(
      fragment
    );

    this.activated = true;

    this.updateStatus(value);
  }
}

if (
  !customElements.get(
    'kf-colour-refine'
  )
) {
  customElements.define(
    'kf-colour-refine',
    KFColourRefine
  );
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-devonstone-fashion-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kf-devonstone-fashion')) {
    class KfDevonstoneFashion extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-fashion-viewport]');
        this.slides = [...this.querySelectorAll('[data-fashion-slide]')];
        if (!this.viewport || this.slides.length < 2) return;

        this.previous = this.querySelector('[data-fashion-previous]');
        this.next = this.querySelector('[data-fashion-next]');
        this.current = this.querySelector('[data-fashion-current]');
        this.index = 0;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

        this.onScroll = () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        };
        this.onPrevious = () => this.goTo(this.index - 1);
        this.onNext = () => this.goTo(this.index + 1);
        this.onKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        };
        this.onBlockSelect = (event) => {
          const slide = event.target.closest('[data-fashion-slide]');
          if (slide) this.goTo(this.slides.indexOf(slide));
        };

        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.onKeydown);
        this.previous?.addEventListener('click', this.onPrevious);
        this.next?.addEventListener('click', this.onNext);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver = new ResizeObserver(() => this.goTo(this.index, true));
        this.resizeObserver.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        if (!this.viewport || this.slides.length < 2) return;
        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('keydown', this.onKeydown);
        this.previous?.removeEventListener('click', this.onPrevious);
        this.next?.removeEventListener('click', this.onNext);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
      }

      goTo(index, immediate = false) {
        const destination = Math.max(0, Math.min(index, this.slides.length - 1));
        const left = this.slides[destination].offsetLeft - this.slides[0].offsetLeft;
        this.viewport.scrollTo({
          left,
          behavior: immediate || this.reducedMotion.matches ? 'auto' : 'smooth',
        });
        this.index = destination;
        this.updateControls();
      }

      update() {
        const offset = this.slides[0].offsetLeft;
        const position = this.viewport.scrollLeft;
        let closest = 0;
        let distance = Infinity;

        this.slides.forEach((slide, index) => {
          const delta = Math.abs(slide.offsetLeft - offset - position);
          if (delta < distance) {
            closest = index;
            distance = delta;
          }
        });

        this.index = closest;
        this.updateControls();
      }

      updateControls() {
        if (this.current) this.current.textContent = String(this.index + 1);
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      }
    }

    customElements.define('kf-devonstone-fashion', KfDevonstoneFashion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-featured-fabric-swatches"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseSwatches = (section) => {
      if (section.dataset.kfSwatchesInitialised === 'true') return;

      const track = section.querySelector('[data-kf-swatch-track]');
      const controls = section.querySelector('[data-kf-slider-controls]');
      const previousButton = section.querySelector('[data-kf-slider-previous]');
      const nextButton = section.querySelector('[data-kf-slider-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      section.dataset.kfSwatchesInitialised = 'true';

      const isSlider = () => {
        return section.classList.contains(
          'kf-featured-swatches--layout-slider'
        );
      };

      const getGap = () => {
        const trackStyles = window.getComputedStyle(track);

        return (
          parseFloat(
            trackStyles.columnGap || trackStyles.gap
          ) || 0
        );
      };

      const updateGridColumns = () => {
        if (isSlider()) return;

        const items = track.querySelectorAll(
          '.kf-featured-swatches__item'
        );

        if (!items.length) return;

        const sectionStyles = window.getComputedStyle(section);

        const preferredCardWidth =
          parseFloat(
            sectionStyles.getPropertyValue(
              '--kf-swatch-card-width'
            )
          ) || 320;

        const maximumColumns =
          parseInt(
            sectionStyles.getPropertyValue(
              '--kf-swatch-maximum-columns'
            ),
            10
          ) || 4;

        const gap = getGap();
        const availableWidth = track.clientWidth;

        const fittingColumns = Math.max(
          1,
          Math.floor(
            (availableWidth + gap) /
            (preferredCardWidth + gap)
          )
        );

        const currentColumns = Math.max(
          1,
          Math.min(
            maximumColumns,
            items.length,
            fittingColumns
          )
        );

        track.style.setProperty(
          '--kf-swatch-current-columns',
          currentColumns
        );
      };

      const getScrollAmount = () => {
        const firstCard = track.querySelector(
          '.kf-featured-swatches__item'
        );

        return firstCard
          ? firstCard.getBoundingClientRect().width + getGap()
          : track.clientWidth;
      };

      const updateSliderControls = () => {
        if (!isSlider()) {
          controls.hidden = true;
          return;
        }

        const maximumScroll = Math.max(
          0,
          track.scrollWidth - track.clientWidth
        );

        const hasOverflow = maximumScroll > 2;

        controls.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled =
          track.scrollLeft >= maximumScroll - 2;
      };

      const updateLayout = () => {
        updateGridColumns();
        updateSliderControls();
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', updateSliderControls, {
        passive: true
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateLayout);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateLayout);
      }

      updateLayout();
    };

    const initialiseAllSwatches = (root = document) => {
      if (root.matches?.('[data-kf-featured-swatches]')) {
        initialiseSwatches(root);
      }

      root
        .querySelectorAll('[data-kf-featured-swatches]')
        .forEach(initialiseSwatches);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialiseAllSwatches();
      });
    } else {
      initialiseAllSwatches();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAllSwatches(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-recommendations"] && !Shopify.designMode) return;
  try {
    
  class KfProductRecommendationsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      const track = this.querySelector('[data-kf-recommendations-track]');
      const controls = this.querySelector('[data-kf-recommendations-controls]');
      const previousButton = this.querySelector('[data-kf-recommendations-previous]');
      const nextButton = this.querySelector('[data-kf-recommendations-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      const getGap = () => {
        const trackStyles = window.getComputedStyle(track);
        return parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
      };

      const getScrollAmount = () => {
        const firstItem = track.querySelector('.kf-product-recommendations__item');
        return firstItem ? firstItem.getBoundingClientRect().width + getGap() : track.clientWidth;
      };

      const updateControls = () => {
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const hasOverflow = maximumScroll > 2;

        controls.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
      };

      previousButton.addEventListener(
        'click',
        () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }),
        { signal }
      );

      nextButton.addEventListener(
        'click',
        () => track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }),
        { signal }
      );

      track.addEventListener('scroll', updateControls, { passive: true, signal });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(updateControls);
        this.resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateControls, { signal });
      }

      requestAnimationFrame(updateControls);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.abortController = null;
      this.resizeObserver = null;
    }
  }

  if (!customElements.get('kf-product-recommendations-carousel')) {
    customElements.define('kf-product-recommendations-carousel', KfProductRecommendationsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-single-colour-search"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const SWATCHES = [
    ['Blush', '#F5D8DD'], ['Rose', '#ECA8BB'], ['Pink', '#D9799D'], ['Raspberry', '#B43E6E'], ['Plum', '#81334D'], ['Soft red', '#E8A6A2'], ['Coral', '#E9817A'], ['Scarlet', '#C8474F'], ['Berry', '#9C334D'], ['Deep red', '#752E38'], ['Peach', '#F5CAAE'], ['Apricot', '#EFAD82'],
    ['Orange', '#E88F42'], ['Rust', '#B75C37'], ['Copper', '#8E5039'], ['Butter', '#F5E7A4'], ['Lemon', '#F4D954'], ['Yellow', '#E4C52A'], ['Mustard', '#B6992D'], ['Pistachio yellow', '#CAC018'], ['Pale lime', '#E3E9A3'], ['Lime', '#AFC75D'], ['Olive', '#8A933E'], ['Forest', '#476A44'],
    ['Sage', '#B8CBB0'], ['Eucalyptus', '#8FAE9E'], ['Mint', '#9ED8C5'], ['Leaf green', '#63A36F'], ['Emerald', '#34856C'], ['Teal', '#387E80'], ['Seafoam', '#B1DAD8'], ['Aqua', '#86CCCF'], ['Sky', '#8FC9EA'], ['Blue', '#609BCE'], ['Ocean', '#377CAC'], ['Navy', '#283F70'],
    ['Lilac', '#D5C4E4'], ['Lavender', '#AD99D0'], ['Purple', '#8266AB'], ['Indigo', '#514C87'], ['Wine', '#673E66'], ['Cream', '#F6F0DE'], ['Beige', '#DFD2B9'], ['Tan', '#BDA386'], ['Brown', '#81624E'], ['Chocolate', '#553E33'], ['White', '#F7F7F4'], ['Light grey', '#D1D1CE'], ['Grey', '#92928E'], ['Charcoal', '#535451'], ['Black', '#282827']
  ];
  const BANDS = { touch: { min: 1, max: 20, ideal: 8 }, some: { min: 20, max: 55, ideal: 35 }, mostly: { min: 55, max: 101, ideal: 80 } };
  const HEX_RE = /^#[0-9a-f]{6}$/i;
  let cataloguePromise = null;

  function hexToLab(hex) {
    if (!HEX_RE.test(hex)) return null;
    const v = hex.slice(1);
    const rgb = [0, 2, 4].map(i => parseInt(v.slice(i, i + 2), 16) / 255).map(c => c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92);
    const x = (rgb[0] * .4124564 + rgb[1] * .3575761 + rgb[2] * .1804375) / .95047;
    const y = rgb[0] * .2126729 + rgb[1] * .7151522 + rgb[2] * .0721750;
    const z = (rgb[0] * .0193339 + rgb[1] * .1191920 + rgb[2] * .9503041) / 1.08883;
    const f = c => c > .008856 ? Math.cbrt(c) : (7.787 * c) + (16 / 116);
    const fx = f(x), fy = f(y), fz = f(z);
    return [116 * fy - 16, 500 * (fx - fy), 200 * (fy - fz)];
  }
  function distance(a, b) {
    if (!a || !b) return Infinity;
    return Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]);
  }
  function prepareColours(value) {
    return (Array.isArray(value) ? value : []).filter(c => c && typeof c.hex === 'string' && HEX_RE.test(c.hex))
      .map(c => ({ lab: hexToLab(c.hex), pct: Math.max(0, Number(c.percentage) || 0) }));
  }
  function cleanProducts(data) {
    const seen = new Set();
    const products = [];
    for (const p of data) {
      if (!p || !p.palette || !p.id || seen.has(String(p.id))) continue;
      seen.add(String(p.id));
      const palette = typeof p.palette === 'string' ? safeJSON(p.palette) : p.palette;
      if (!palette) continue;
      const display = prepareColours(palette.colours);
      const analysis = prepareColours(palette.analysis_colours);
      if (!display.length && !analysis.length) continue;
      products.push({ ...p, colours: analysis.length ? analysis : display, display, single: !!palette.single_colour_family });
    }
    return products;
  }
  function safeJSON(value) { try { return JSON.parse(value); } catch (_) { return null; } }
  async function fetchPage(url, page) {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('page', String(page));
    const r = await fetch(u.href, { credentials: 'same-origin' });
    if (!r.ok) throw new Error('Page ' + page + ' returned HTTP ' + r.status);
    const raw = await r.text();
    let json;
    try { json = JSON.parse(raw); } catch (_) {
      throw new Error('Page ' + page + ' returned a page instead of JSON. Confirm the colour feed is available in this theme preview.');
    }
    if (!json || !Array.isArray(json.products)) throw new Error('Page ' + page + ' returned an unexpected data format.');
    return json;
  }
  async function loadCatalogue(url) {
    if (!cataloguePromise) {
      cataloguePromise = (async () => {
        const first = await fetchPage(url, 1);
        const count = Math.max(1, Math.min(100, Number(first.pages) || 1));
        const pages = [first];
        // Load in modest batches so storefront requests do not spike unnecessarily.
        for (let i = 2; i <= count; i += 4) {
          const batch = [];
          for (let p = i; p < Math.min(i + 4, count + 1); p++) batch.push(fetchPage(url, p));
          pages.push(...await Promise.all(batch));
        }
        return cleanProducts(pages.flatMap(page => page.products));
      })().catch(err => { cataloguePromise = null; throw err; });
    }
    return cataloguePromise;
  }
  function matchProduct(p, target, tolerance) {
    const matched = p.colours.map(c => ({ pct: c.pct, diff: distance(c.lab, target) })).filter(c => c.diff <= tolerance && c.pct > 0);
    if (!matched.length && !(p.single && p.display.length === 1 && distance(p.display[0].lab, target) <= tolerance)) return null;
    let coverage = matched.reduce((sum, c) => sum + c.pct, 0);
    let avgDiff = matched.length ? matched.reduce((sum, c) => sum + c.diff * c.pct, 0) / Math.max(.01, coverage) : Infinity;
    if (p.single && p.display.length === 1 && p.display[0].pct >= 98) {
      const singleDiff = distance(p.display[0].lab, target);
      if (singleDiff <= tolerance) {
        coverage = Math.max(coverage, p.display[0].pct);
        avgDiff = Math.min(avgDiff, singleDiff);
      }
    }
    coverage = Math.min(100, coverage);
    if (coverage < 1) return null;
    return { product: p, coverage, difference: avgDiff };
  }
  function matchesBand(value, band) {
    return band === 'any' ? value >= 1 : value >= BANDS[band].min && value < BANDS[band].max;
  }
  function nearestShadeName(hex) {
    const lab = hexToLab(hex);
    const found = SWATCHES.map(([name, swatch]) => ({ name, d: distance(lab, hexToLab(swatch)) })).sort((a, b) => a.d - b.d)[0];
    return found && found.d < 2 ? found.name : 'Your chosen shade';
  }
  function create(tag, className, content) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (content !== undefined) el.textContent = content;
    return el;
  }
  function init(section) {
    if (section.dataset.kfOneReady === 'true') return;
    section.dataset.kfOneReady = 'true';
    const $ = sel => section.querySelector(sel);
    const ui = { swatches: $('[data-kf-one-swatches]'), chip: $('[data-kf-one-chip]'), name: $('[data-kf-one-name]'), picker: $('[data-kf-one-picker]'), count: $('[data-kf-one-count]'), notice: $('[data-kf-one-notice]'), products: $('[data-kf-one-products]'), more: $('[data-kf-one-more]'), similar: $('[data-kf-one-similar]') };
    const query = new URL(window.location.href).searchParams;
    const fromUrl = '#' + (query.get('colour') || '').replace(/^#/, '').toUpperCase();
    const state = { hex: HEX_RE.test(fromUrl) ? fromUrl : '#CAC018', amount: BANDS[query.get('amount')] ? query.get('amount') : 'some', similar: query.get('similar') !== '0', shown: 0, matches: [], products: null, perPage: Math.max(8, Math.min(48, Number(section.dataset.perPage) || 24)) };
    let swatchButtons = [];
    function syncControls() {
      section.style.setProperty('--kf-one-selected', state.hex);
      ui.chip.style.backgroundColor = state.hex;
      ui.name.textContent = nearestShadeName(state.hex);
      ui.picker.value = state.hex;
      ui.similar.checked = state.similar;
      swatchButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hex === state.hex)));
      section.querySelectorAll('[data-kf-one-amount]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.kfOneAmount === state.amount)));
    }
    function updateURL() {
      const url = new URL(window.location.href);
      url.searchParams.set('colour', state.hex.slice(1));
      url.searchParams.set('amount', state.amount);
      url.searchParams.set('similar', state.similar ? '1' : '0');
      window.history.replaceState(window.history.state, '', url.toString());
    }
    function setShade(hex) {
      if (!HEX_RE.test(hex)) return;
      state.hex = hex.toUpperCase();
      state.amount = state.amount === 'any' ? 'some' : state.amount;
      syncControls(); updateURL(); render();
    }
    function addGrid() {
      const fragment = document.createDocumentFragment();
      for (const [name, hex] of SWATCHES) {
        const button = create('button', 'kf-one-colour__swatch');
        button.type = 'button';
        button.style.setProperty('--swatch', hex);
        button.style.setProperty('--swatch-tick', hexToLab(hex)[0] > 61 ? '#272727' : '#fff');
        button.dataset.hex = hex;
        button.setAttribute('aria-label', name);
        button.title = name;
        button.addEventListener('click', () => setShade(hex));
        fragment.appendChild(button);
        swatchButtons.push(button);
      }
      ui.swatches.replaceChildren(fragment);
    }
    function showNotice(message, buttonLabel, action) {
      ui.notice.hidden = false;
      ui.notice.replaceChildren();
      ui.notice.appendChild(create('p', null, message));
      if (buttonLabel) {
        const button = create('button', 'kf-one-colour__retry', buttonLabel);
        button.type = 'button';
        button.addEventListener('click', action);
        ui.notice.appendChild(button);
      }
    }
    function hideNotice() { ui.notice.hidden = true; ui.notice.replaceChildren(); }
    function productCard(entry) {
      const p = entry.product;
      const card = create('article', 'kf-one-colour__product');
      const link = create('a', 'kf-one-colour__product-link');
      link.href = p.url && String(p.url).startsWith('/') ? p.url : '/products/' + encodeURIComponent(p.handle || '');
      if (p.image) {
        const img = create('img', 'kf-one-colour__product-img');
        img.src = p.image; img.alt = p.title || ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = 560; img.height = 560;
        link.appendChild(img);
      }
      link.appendChild(create('span', 'kf-one-colour__product-title', p.title || 'Fabric'));
      card.appendChild(link);
      const meta = create('div', 'kf-one-colour__product-meta');
      meta.appendChild(create('span', 'kf-one-colour__product-coverage', `Approx. ${Math.round(entry.coverage)}% this shade`));
      meta.appendChild(create('span', 'kf-one-colour__product-price', p.available === false ? 'Sold out' : (p.price || '')));
      card.appendChild(meta);
      return card;
    }
    function appendMore() {
      const next = state.matches.slice(state.shown, state.shown + state.perPage);
      const fragment = document.createDocumentFragment();
      for (const entry of next) fragment.appendChild(productCard(entry));
      ui.products.appendChild(fragment);
      state.shown += next.length;
      ui.more.hidden = state.shown >= state.matches.length;
    }
    function render() {
      if (!state.products) return;
      const target = hexToLab(state.hex);
      const tolerance = state.similar ? 22 : 10; // CIELAB Delta E 1976, test thresholds only.
      const matched = state.products.map(p => matchProduct(p, target, tolerance)).filter(Boolean);
      state.matches = matched.filter(e => matchesBand(e.coverage, state.amount)).sort((a,b) => {
        if (!!a.product.available !== !!b.product.available) return a.product.available ? -1 : 1;
        const ideal = BANDS[state.amount]?.ideal || 35;
        const sa = a.difference + Math.abs(a.coverage - ideal) * .12;
        const sb = b.difference + Math.abs(b.coverage - ideal) * .12;
        return sa - sb;
      });
      state.shown = 0;
      ui.products.replaceChildren();
      ui.count.textContent = `${state.matches.length} ${state.matches.length === 1 ? 'fabric' : 'fabrics'} found`;
      ui.more.hidden = true;
      hideNotice();
      if (!state.matches.length) {
        if (matched.length) showNotice('We found this colour, but not in the amount you chose. Try another amount to see those fabrics.', 'Show fabrics with any amount', () => { state.amount = 'any'; syncControls(); updateURL(); render(); });
        else if (!state.similar) showNotice('No close matches for this shade yet. Try including similar shades.', 'Include similar shades', () => { state.similar = true; syncControls(); updateURL(); render(); });
        else showNotice('No fabrics found for this shade yet. Try selecting a neighbouring colour from the grid.');
        return;
      }
      appendMore();
    }
    addGrid();
    section.querySelectorAll('[data-kf-one-amount]').forEach(button => button.addEventListener('click', () => {
      state.amount = button.dataset.kfOneAmount;
      syncControls(); updateURL(); render();
    }));
    ui.picker.addEventListener('input', event => setShade(event.target.value));
    ui.similar.addEventListener('change', event => { state.similar = event.target.checked; updateURL(); render(); });
    ui.more.addEventListener('click', appendMore);
    syncControls();
    loadCatalogue(section.dataset.feedUrl).then(products => {
      if (!section.isConnected) return;
      state.products = products;
      if (!products.length) { showNotice('No analysed fabrics were returned from the colour catalogue.'); ui.count.textContent = 'No colour data found'; return; }
      render();
    }).catch(error => {
      console.error('Koala single-colour search:', error);
      ui.count.textContent = 'Unable to load colour results';
      showNotice('Could not load the fabric catalogue: ' + (error?.message || 'Unknown error') + '.', 'Try again', () => window.location.reload());
    });
  }
  function start(root) { (root || document).querySelectorAll('[data-kf-one-colour]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start()); else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
